import MaxWidthWrapper from "./components/common/MaxWidthWrapper";
import CircularProgress from "./components/progresses/CircularProgress";
import LinearProgress1 from "./components/progresses/LinearProgress1";
import LinearProgress2 from "./components/progresses/LinearProgress2";
import LinearProgress3 from "./components/progresses/LinearProgress3";

const App = () => {
  return (
    <MaxWidthWrapper>
      {/* ============== Circular Progresse ============== */}
      <div className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4">
        <CircularProgress
          title="Next.js"
          value={90}
          color="blue"
          pathWidth={8}
        />

        <CircularProgress
          title="Wordpress"
          value={83}
          color="teal"
          size={100}
        />

        <CircularProgress
          title="Laravel"
          value={78}
          color="purple"
          pathWidth={10}
        />

        <CircularProgress
          title="Angular.js"
          value={76}
          color="lime"
          size={100}
        />

        <CircularProgress
          title="React"
          value={69}
          color="pink"
          pathWidth={12}
        />
      </div>
      {/* ============== Circular Progresse ============== */}

      {/* | */}
      {/* | */}
      {/* | */}
      <hr />
      {/* | */}
      {/* | */}
      {/* | */}

      {/* ============== Linear Progresse 1 ============== */}
      <div className="grid lg:grid-cols-2 gap-4">
        <LinearProgress1
          title="Next.js"
          value={90}
          color="blue"
          pathWidth={4}
        />
        <LinearProgress1
          title="Next.js"
          value={78}
          color="teal"
          pathWidth={4}
        />
        <LinearProgress1
          title="Next.js"
          value={93}
          color="pink"
          pathWidth={6}
        />
        <LinearProgress1
          title="Next.js"
          value={68}
          color="fuchsia"
          pathWidth={6}
        />
        <LinearProgress1
          title="Next.js"
          value={48}
          color="black"
          pathWidth={10}
        />
        <LinearProgress1
          title="Next.js"
          value={95}
          color="orange"
          pathWidth={10}
        />
      </div>
      {/* ============== Linear Progresse 1 ============== */}

      {/* | */}
      {/* | */}
      {/* | */}
      <hr />
      {/* | */}
      {/* | */}
      {/* | */}

      {/* ============== Linear Progresse 2 ============== */}
      <div className="grid lg:grid-cols-2 gap-4">
        <LinearProgress2 title="Next.js" value={95} color="blue" />
        <LinearProgress2 title="PHP" value={75} color="teal" />
        <LinearProgress2 title="Express.js" value={49} color="green" />
        <LinearProgress2 title="Node.js" value={76} color="orange" />
        <LinearProgress2 title="Tailwindcss" value={98} color="pink" />
        <LinearProgress2 title="TypeScript" value={25} color="yellow" />
      </div>
      {/* ============== Linear Progresse 2 ============== */}

      {/* | */}
      {/* | */}
      {/* | */}
      <hr />
      {/* | */}
      {/* | */}
      {/* | */}

      {/* ============== Linear Progresse 3 ============== */}
      <div className="grid lg:grid-cols-2 gap-4">
        <LinearProgress3 title="Next.js" value={95} color="blue" />
        <LinearProgress3 title="PHP" value={75} color="red" />
        <LinearProgress3 title="Express.js" value={49} color="green" />
        <LinearProgress3 title="Node.js" value={76} color="cyan" />
        <LinearProgress3 title="Tailwindcss" value={98} color="pink" />
        <LinearProgress3 title="TypeScript" value={25} color="fuchsia" />
      </div>
      {/* ============== Linear Progresse 3 ============== */}

      <hr />
      <hr />
      <hr />
      <hr />
    </MaxWidthWrapper>
  );
};

export default App;
